import React from "react";
// You might want to use a phone icon from a library like 'react-icons' or simply use text/emoji
// import { FiPhone } from "react-icons/fi"; // Example using react-icons

const FloatingCallButton = ({ phoneNumber, buttonText = "Call Now" }) => {
  // Function to handle the button click
  const handleCallClick = () => {
    // The 'tel:' scheme prompts the device's phone application
    window.location.href = `tel:${phoneNumber}`;
  };

  // Basic styling for a floating button
  const buttonStyle = {
    position: "fixed",
    // 20px / 16 = 1.25rem
    bottom: "8.5rem",
    right: "2.25rem",
    backgroundColor: "#007bff",
    color: "white",
    borderRadius: "50%",
    // 60px / 16 = 3.75rem
    width: "5.75rem",
    height: "5.75rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // 4px / 16 = 0.25rem; 8px / 16 = 0.5rem
    boxShadow: "0 0.25rem 0.5rem rgba(0, 0, 0, 0.2)",
    cursor: "pointer",
    zIndex: 1000,
    border: "none",
    // 24px / 16 = 1.5rem
    fontSize: "1.5rem",
    textDecoration: "none",
  };

  return (
    <a
      href={`tel:${phoneNumber}`} // Use an anchor tag with tel: for accessibility and fallback
      style={buttonStyle}
      aria-label={buttonText}
      title={buttonText}
    >
      <i className="fa-solid fa-phone"></i> {/* Using the phone icon */}
    </a>
  );
};

export default FloatingCallButton;
